function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import cn from "classnames";
import { noop } from "../../lib/utils";
import "../../styles/ui/select.scss";

const Select = ({
  children,
  className,
  name,
  onChange = noop,
  options = [],
  value,
  ...props
}) => {
  const onSelectChange = event => {
    onChange(event.target.value);
  };

  return /*#__PURE__*/React.createElement("select", _extends({
    className: cn("otrl-ui__select", className),
    name: name,
    onChange: onSelectChange,
    value: value
  }, props), options.map((option, index) => /*#__PURE__*/React.createElement("option", {
    key: index,
    value: option.value
  }, option.label)), children);
};

export default Select;